<div  cdkDropList 
      [cdkDropListData]="{
        groupIdx: groupIndex
      }" 
      
      (cdkDropListDropped)="drop($event)" 
      class="flex-column gap-none"
      #groupDiv
  >
  <ng-container *ngFor="
      let activity of activities;
      trackBy: trackActivityById;
      let idx = index
    ">
    <ss-activity-item [activity]="activity" [activityId]="activity.id"></ss-activity-item>
  </ng-container>
</div>